






































import Vue from 'vue';
import { Auth } from "aws-amplify";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import SignIn from './auth-sign-in.vue';
import AuthSignUp from './auth-sign-up.vue';
import AuthConfirmSignUp from './auth-confirm-sign-up.vue';
import AuthForgotPassword from './auth-forgot-password.vue';
import AuthRequirePassword from './auth-require-password.vue';
import AuthConfirmPasswordChange from './auth-confirm-password-change.vue';

export default Vue.extend({
  name: 'CustomAuthenticator',
  props: ['confirmationCode', 'confirmationUsername', 'startingState'],
  components: {
    "auth-sign-in": SignIn,
    "auth-sign-up": AuthSignUp,
    "auth-confirm-sign-up": AuthConfirmSignUp,
    "auth-forgot-password": AuthForgotPassword,
    "auth-require-password": AuthRequirePassword,
    "auth-confirm-password-change": AuthConfirmPasswordChange
  },
  data() {
    return {
      user: {
        username: null
      },
      displayMap: {},
      error: '',
      logger: {},
    }
  },
  computed: {
    options(): any {
      return {
        signInConfig: {},
        signUpConfig: {},
        confirmSignUpConfig: {},
        confirmSignInConfig: {},
        forgotPasswordConfig: {},
        mfaConfig: {},
        requireNewPasswordConfig: {},
        usernameAttributes: 'username'
      };
    }
  },
  mounted() {
    AmplifyEventBus.$on('localUser', (user: any) => {
      this.user = user;
      this.options.signInConfig.username = this.user.username;
      this.options.confirmSignInConfig.user = this.user;
      this.options.confirmSignUpConfig.username = this.user.username;
      this.options.requireNewPasswordConfig.user = this.user;
    });
    AmplifyEventBus.$on('authState', (data: any) => {
      this.displayMap = this.updateDisplayMap(data)
    });
    if (this.startingState) {
      this.displayMap = this.updateDisplayMap(this.startingState);
    } else {
      Auth.currentAuthenticatedUser()
        .then(user => {
          this.user = user;
          return this.displayMap = this.updateDisplayMap('signedIn');
        })
        .catch(e => {
          this.setError(e)
          return this.displayMap = this.updateDisplayMap('signedOut')
        });
    }
  },
  methods: {
    signUp() {
      AmplifyEventBus.$emit('authState', 'signUp')
    },
    signIn: function () {
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    updateDisplayMap: (state: string) => {
      return {
        showSignIn: state === 'signedOut' || state === 'signIn',
        showSignUp: state === 'signUp',
        showConfirmSignUp: state === 'confirmSignUp',
        showConfirmSignIn: state === 'confirmSignIn',
        showForgotPassword: state === 'forgotPassword',
        showSignOut: state === 'signedIn',
        showMfa: state === 'setMfa',
        requireNewPassword: state === 'requireNewPassword',
        showChangePasswordConfirm: state === 'confirmPasswordChange'
      }
    },
    setError: function (e: any) {
      this.error = e.message || e;
    }
  }
})
